import Vue from "vue";
import Router from "vue-router";
import Landing from "@/views/Landing";
import FlexView from "@/views/FlexView";
import SoR from "@/views/SoR";
import Users from "@/views/Users";
import UserCreate from "@/views/UserCreate";
import User from "@/views/User";
import SoRs from "@/views/SoRs";
import Settings from "@/views/Settings";
import Abbreviations from "@/views/Abbreviations";
import Contracts from "@/views/Contracts";
import ContractPercentageFluctuationList from "@/views/ContractPercentageFluctuationList";
import ContractPercentageFluctuation from "@/views/ContractPercentageFluctuation";
import ContractPercentageYearConfig from "@/views/ContractPercentageYearConfig";
import Volume from "@/views/Volume";
import Contract from "@/views/Contract";
import UnicodeEscapes from "@/views/UnicodeEscapes";
import Corrigendum from "@/views/Corrigendum";
import ASoR from "@/views/ASoR";
import AsorRbu from "@/views/AsorRbu.vue";
import AsorRbuItem from "@/views/AsorRbuItem";
import AsorRbuConfig from "@/views/AsorRbuConfig.vue";
import ContractWorkOrders from "@/views/ContractWorkOrders";
import WorkOrder from "@/views/WorkOrder";
import PublicDimBook from "@/views/PublicDimBook";
import Nsr from "@/views/Nsr";
import NsrRbu from "@/views/NsrRbu";
import AdfsWhiteList from "@/views/AdfsWhiteList";
import Datasets from "@/views/rbu/Datasets.vue";
import Dataset from "@/views/rbu/Dataset.vue";
import DatasetIssue from "@/views/rbu/DatasetIssue.vue";
import DatasetIgnore from "@/views/rbu/DatasetIgnore.vue";
import RbuEditions from "@/views/rbu/RbuEditions.vue";
import RbuEdition from "@/views/rbu/RbuEdition.vue";
import RbuEditionConfigure from "@/views/rbu/RbuEditionConfigure.vue";
import RbuSectionFluctuation from "@/views/rbu/RbuSectionFluctuation.vue";
import RbuSection from "@/views/rbu/RbuSection.vue";
import RbuVolume from "@/views/rbu/RbuVolume.vue";
import RbuItem from "@/views/rbu/RbuItem.vue";
import RbuItemExtra from "@/views/rbu/RbuItemExtra.vue";
import RbuAdmins from "@/views/rbu/RbuAdmins.vue";
import TemplateVerification from "@/views/TemplateVerification.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "landing",
      component: Landing,
    },
    {
      path: "/whitelist",
      name: "whitelist",
      component: AdfsWhiteList,
    },
    {
      path: "/template-verification",
      name: "template-verification",
      component: TemplateVerification,
      meta: {
        requiresPermission: "MANAGE_RBU_TEMPLATE_VERIFICATION",
      },
    },
    {
      path: "/user",
      component: FlexView,
      children: [
        {
          path: "",
          name: "user-list",
          component: Users,
        },
        {
          path: "create",
          name: "user-create",
          component: UserCreate,
        },
        {
          path: ":userId",
          name: "user-detail",
          component: User,
        },
      ],
    },
    {
      path: "/sor",
      component: FlexView,
      children: [
        {
          path: "",
          name: "sor-list",
          component: SoRs,
        },
        {
          path: ":sorId",
          name: "sor-detail",
          component: SoR,
        },
        {
          path: ":sorId/:volumeId",
          name: "sor-volume",
          component: Volume,
        },
        // {
        //     path: ':sorId/:sectionId',
        //     name: 'sor-section-detail',
        //     component: Section,
        // },
      ],
    },
    {
      path: "/corrigendum",
      component: FlexView,
      children: [
        {
          path: ":corrigendumId",
          name: "corrigendum-detail",
          component: Corrigendum,
        },
      ],
    },
    {
      path: "/contract",
      component: FlexView,
      children: [
        {
          path: "",
          name: "contract-list",
          component: Contracts,
        },
        {
          path: ":contractId/",
          component: FlexView,
          children: [
            {
              path: "",
              name: "contract-detail",
              component: Contract,
            },
            {
              path: "contract_percentage/:contract_percentage_id/",
              component: FlexView,
              children: [
                {
                  path: "",
                  name: "contract-percentage-list",
                  component: ContractPercentageFluctuationList,
                },
                {
                  path: "fluctuation/:contractPercentageSectionId",
                  name: "contract-percentage-section-fluctuation",
                  component: ContractPercentageFluctuation,
                },
                {
                  path: "config",
                  name: "contract-percentage-year-config",
                  component: ContractPercentageYearConfig,
                },
              ],
            },
          ],
        },
        {
          path: "a_sor/:aSorId",
          component: FlexView,
          children: [
            {
              path: "",
              name: "a-sor-detail",
              component: ASoR,
            },
            {
              path: "a_sor_rbu/",
              component: FlexView,
              children: [
                {
                  path: "",
                  name: "a-sor-rbu-section",
                  component: AsorRbu,
                },
                {
                  path: "a_sor_rbu_item/:rbuItemId",
                  name: "a-sor-rbu-item-detail",
                  component: AsorRbuItem,
                },
                {
                  path: "config/",
                  name: "a-sor-rbu-config",
                  component: AsorRbuConfig,
                },
              ],
            },
          ],
        },
        {
          path: "work_orders/:contractId",
          name: "contract-work-orders",
          component: ContractWorkOrders,
        },
        {
          path: "work_order/:workOrderId",
          name: "work-order-detail",
          component: WorkOrder,
        },
      ],
    },
    {
      path: "/nsr_items",
      component: FlexView,
      children: [
        {
          path: "",
          name: "nsr-items",
          component: Nsr,
        },
        {
          path: ":nsrItemId",
          name: "nsr-item-rbu",
          component: NsrRbu,
        },
      ],
    },
    {
      path: "/settings",
      component: FlexView,
      children: [
        {
          path: "",
          name: "settings",
          component: Settings,
        },
        {
          path: "abbreviations",
          name: "settings-abbreviations",
          component: Abbreviations,
        },
        {
          path: "unicode_escapes",
          name: "settings-unicode-escapes",
          component: UnicodeEscapes,
        },
      ],
    },
    {
      path: "/public",
      component: FlexView,
      children: [
        {
          path: "",
          name: "public-dim-book",
          component: PublicDimBook,
        },
      ],
    },
    {
      path: "/dataset",
      component: FlexView,
      children: [
        {
          path: "",
          name: "rbu-datasets",
          component: Datasets,
        },
        {
          path: ":datasetId",
          component: FlexView,
          children: [
            {
              path: "",
              name: "rbu-dataset",
              component: Dataset,
            },
            {
              path: "issue/:issueId",
              name: "rbu-dataset-issue",
              component: DatasetIssue,
            },
            {
              path: "ignore-list/:issueId",
              name: "rbu-ignore-list",
              component: DatasetIgnore,
            },
          ],
        },
      ],
    },
    {
      path: "/rbu",
      component: FlexView,
      children: [
        {
          path: "",
          name: "rbu-edition-list",
          component: RbuEditions,
        },
        {
          path: ":editionId/",
          component: FlexView,
          children: [
            {
              path: "",
              name: "rbu-edition-detail",
              component: RbuEdition,
            },
            {
              path: "configure/",
              name: "rbu-edition-configure",
              component: RbuEditionConfigure,
            },
            {
              path: "volume/:volumeId/",
              component: FlexView,
              children: [
                {
                  path: "",
                  name: "rbu-volume-detail",
                  component: RbuVolume,
                },
                {
                  path: "admin",
                  name: "rbu-admin-detail",
                  component: RbuAdmins,
                },
              ],
            },
            {
              path: "section/:sectionId/",
              component: FlexView,
              children: [
                {
                  path: "",
                  name: "rbu-section-detail",
                  component: RbuSection,
                },
                {
                  path: "fluctuation/",
                  name: "rbu-section-fluctuation",
                  component: RbuSectionFluctuation,
                },
                {
                  path: "item/:itemId/",
                  name: "rbu-item",
                  component: RbuItem,
                },
                {
                  path: "item_extra/:rbu_item_extra_section_id/",
                  name: "rbu-item-extra",
                  component: RbuItemExtra,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
